import { store } from '@betacrew/jars-flux'
export const componentKey = "FORM_1094C";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setTempFormFieldsList: (state, action) => {
            state.tempFormFieldsList = [...action.payload];
        },
        setOnDependentFields: (state, action) => {
            state.onDependentFields = action.payload;
        },
        setToCreateFormData: (state, action) => {
            state.toCreateFormData = { ...state.toCreateFormData, ...action.payload };
        },
        setFormsPreLoadedData: (state, action) => {
            state.formsPreLoadedData = action.payload;
        },
        updateFormsPreLoadedData: (state, action) => {
            state.formsPreLoadedData = {
                ...state.formsPreLoadedData,
                ...action.payload,
            }
        },
        updateUserInteractionPopupWResponseObj: (state, action) => {
            state.userInteractionPopupWResponseObj = {
                ...state.userInteractionPopupWResponseObj,
                ...action.payload,
            };
        },
        resetUserInteractionPopupWResponseObj: (state, action) => {
            state.userInteractionPopupWResponseObj = {};
        },
        setSuccessfullySubmitted1094c: (state, action) => {
            state.successfullySubmitted1094c = action.payload;
        },
        setFormDataFromRecordId: (state, action) => {
            state.formDataFromRecordId = action.payload;
        },
        setIsIncorrectFormRecordId: (state, action) => {
            state.isIncorrectFormRecordId = action.payload;
        },
    }, 
    initialReducerState: {
        loadingState: false,
        tempFormFieldsList: [],
        onDependentFields: {},
        formsPreLoadedData: {},
        toCreateFormData: {
            selectedYear: null,
            selectedForm: null,
            selectedPayer: null,
        },
        userInteractionPopupWResponseObj: {},
        successfullySubmitted1094c: false,
        formDataFromRecordId: null,
        isIncorrectFormRecordId: null,
    }
});
export const { 
    setLoadingState,
    setTempFormFieldsList,
    setFormsPreLoadedData,
    updateFormsPreLoadedData,
    setOnDependentFields,
    updateUserInteractionPopupWResponseObj,
    resetUserInteractionPopupWResponseObj,
    setToCreateFormData,
    setSuccessfullySubmitted1094c,
    setFormDataFromRecordId,
    setIsIncorrectFormRecordId,
} = actions;